<div class="container">
  <div>
    <div class="caption" (click)="onTap()">Login Baulogistik</div>
    <div class="subcaption">(Version {{ state.version }})</div>
    <br />
    <ion-input
      label="Benutzername"
      labelPlacement="floating"
      fill="outline"
      [(ngModel)]="username"
      mode="md"
    ></ion-input>
    <br />
    <ion-input
      mode="md"
      label="Passwort"
      labelPlacement="floating"
      fill="outline"
      type="password"
      (keyup.enter)="login()"
      [(ngModel)]="password"
      ><ion-input-password-toggle slot="end"></ion-input-password-toggle
    ></ion-input>
    <br />
    <!--ion-checkbox
      [(ngModel)]="stayLoggedIn"
      labelPlacement="end"
      style="margin-left: 2px"
      >Angemeldet bleiben</ion-checkbox
      -->

    <ion-button
      style="width: 100%"
      (click)="login()"
      [disabled]="password == null || username == null"
      >Einloggen</ion-button
    >

    <div class="error">{{ errorMessage }}</div>
  </div>
</div>
